<template>
<div class="page-header">
  <div class="container">
    <a class="logo" href="https://www.upyun.com/" target="_blank">
      <img src="../..//assets/logo.svg" />
    </a>
    <div class="side-navs">
      <a class="console" href="https://console.upyun.com" target="_blank">控制台首页</a>
      <a class="profile" @mouseenter='mouseEnter' @mouseleave="mouseLeave">
        {{profile.name}}
        <i class="el-icon-caret-bottom arrow-down"></i>
        <div class="logout" :class="{show: showLogout, hide: !showLogout}" @click="logOut">退出登录</div>
      </a>
    </div>
  </div>
</div>
</template>

<script>
import { resetRouter } from '@/routes'
import { getCookie, clearCookie, setCookie } from '@/utils/cookie'
import config from '../../../config'

export default {
  data () {
    return {
      showLogout: false
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile;
    }
  },
  props: ['navNum'],
  mounted () {
    const smsToken = getCookie('cookieToken');
    if (smsToken && Object.keys(this.$store.state.profile).length === 0) {
      this.$store.dispatch('getProfile', {router: this.$router});
    }
  },
  methods: {
    mouseEnter () {
      this.showLogout = true;
    },
    mouseLeave () {
      this.showLogout = false;
    },
    logOut () {
      window.sessionStorage.removeItem('role') // 删除用户信息
      clearCookie('cookieToken');
      clearCookie('crmToken');
      resetRouter() // 路由重置
      if (process.env.NODE_ENV === 'development') {
        window.location.href = 'http://franky.upyun.com:7001/accounts/signout/';
      } else {
        window.location.href = 'https://console.upyun.com/accounts/signout/';
      }
    }
  },
  created () {
    // first
    const smsToken = getCookie('cookieToken');
    const frankyToken = this.$route.query.token;
    const crmToken = this.$route.query.crmToken; // 获取 crmToken

    // crm 跳转登录
    if (crmToken) {
      clearCookie('cookieToken');
      setCookie('crmToken', `JWT ${crmToken}`, 1);
      this.$store.dispatch('getProfile', {router: this.$router});
      this.$router.push('/dashboard');
      return;
    }

    // 正常登录
    if (frankyToken) {
      clearCookie('cookieToken');
      this.$store.dispatch('getToken', {
        // 传递 url-token 调用接口 200 后端生成token 设置 cookieToken 调用获取用户信息，并跳转路由
        token: frankyToken,
        router: this.$router
      });
      return;
    }

    // 未登录: 如果没有本地token
    if (!smsToken) {
      if (process.env.NODE_ENV === 'development') {
        window.location.href = config.dev.login_url;
      } else {
        window.location.href = config.build.login_url;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// headers.vue?82805d1e